/**
 * Appointments Service
 * All appointment-related database operations using Supabase.
 */

import { SupabaseService } from './supabaseService';
import { TABLES } from './tables';

export class AppointmentsService extends SupabaseService {
  /**
   * Get all appointments.
   */
  static async getAll() {
    return super.getAll(TABLES.APPOINTMENTS);
  }

  /**
   * Create a new appointment.
   * @param {Object} data - { client, start_time, end_time, details, added_by, apt_label }
   * @returns {Promise<string>} New row id
   */
  static async createAppointment(data) {
    return this.create(TABLES.APPOINTMENTS, {
      client: data.client,
      start_time: data.start_time,
      end_time: data.end_time,
      details: data.details ?? '',
      added_by: data.added_by,
      apt_label: data.apt_label ?? ''
    });
  }

  /**
   * Update an appointment (e.g., notes/details).
   * @param {string} appointmentId
   * @param {Object} updates
   */
  static async updateAppointment(appointmentId, updates) {
    return this.update(TABLES.APPOINTMENTS, appointmentId, updates);
  }

  /**
   * Delete an appointment.
   * @param {string} appointmentId
   */
  static async deleteAppointment(appointmentId) {
    return this.delete(TABLES.APPOINTMENTS, appointmentId);
  }
}
